import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=2cca0058&scoped=true&"
import script from "./Contests.vue?vue&type=script&lang=ts&"
export * from "./Contests.vue?vue&type=script&lang=ts&"
import style0 from "./Contests.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Contests.vue?vue&type=style&index=1&id=2cca0058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca0058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSheet,VTab,VTabs})
